import { render, staticRenderFns } from "./houseadd.vue?vue&type=template&id=056f983a&scoped=true&"
import script from "./houseadd.vue?vue&type=script&lang=js&"
export * from "./houseadd.vue?vue&type=script&lang=js&"
import style0 from "./houseadd.vue?vue&type=style&index=0&id=056f983a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f983a",
  null
  
)

component.options.__file = "houseadd.vue"
export default component.exports